import { useEffect, useState } from 'react';
import Menu from '../components/TabMenu';
import GameModeMenu from '../components/GameModeMenu';
import CountryRanking from '../components/CountryRanking';
import { SERVER_HOST } from '../settings';

export default function CountriesRanking() {

    const [rankingType, setRankingType] = useState();

    const tabContentFn = (gameMode, rankingType) => {
        return <CountryRanking gameMode={gameMode.key} rankingType={rankingType}></CountryRanking>
    }
    const [latestBatch, setLatestBatch] = useState('');

    useEffect(() => {
        const url = `${SERVER_HOST}/latestBatches`;
        fetch(url).then(data => data.json()).then((data) => {
            setLatestBatch(new Date(data?.overall)?.toLocaleString());
        })
    });

    return (
        <div>
            <Menu setRankingTypeFn={setRankingType}></Menu>
            <h3 class="text-align-center">Last ranking update: {latestBatch}</h3>
            <GameModeMenu tabContentFn={tabContentFn} rankingType={rankingType}></GameModeMenu>
        </div>
    );
};